document.addEventListener("DOMContentLoaded", function() {
  const closeButton = document.querySelector(".app-pop-up__close"), appPopUp = document.querySelector(".app-pop-up");
  const closeBanner = document.querySelector(".app-banner__close"), appBanner = document.querySelector(".app-banner");
  closeButton && appPopUp && closeButton.addEventListener("click", function() {
    appPopUp.style.display = "none";
    appBanner.style.display = "block"
  })
  closeBanner && appBanner && closeBanner.addEventListener("click", function() {
    appBanner.style.display = "none"
  })
});